import React from "react";
import { Helmet } from "react-helmet";

import { useNavigate } from "react-router-dom";

import Layout from "../reusable-components/Layout";
import { useAppContext } from "../context/ThemeContext";

function ErrorPage() {
	const navigate = useNavigate();
	const { siteTheme } = useAppContext();

	return (
		<>
			<Helmet>
				<title>Wiingr | Not Found</title>
			</Helmet>
			<Layout>
				<div className="mx-auto max-w-max-content-width h-[100vh] flex justify-center items-center px-4 text-center leading-5 font-thin">
					<div>
						<h1 className="text-2xl font-normal border-b-[1px] pb-3 mb-5">
							Oops!
						</h1>
						<p className="pt-1 text-base font-thin">
							It seems that we are unable to locate the page you are searching
							for.
						</p>
						<div className="w-full mx-auto mt-20 text-brandBlack">
							<button
								className={`${siteTheme?.textColor} px-4 text-xs w-fit p-1 border-[0.5px] border-neutral-700 rounded-2xl bg-[rgba(250,250,250,0.03)]`}
								type="button"
								onClick={() => {
									navigate("/");
								}}>
								Back to Wiingr
							</button>
						</div>
					</div>
				</div>
			</Layout>
		</>
	);
}

export default ErrorPage;
